module.exports = __webpack_public_path__ + "static/img/ad-9.0472499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-9.png
// module id = D0m3
// module chunks = 0